import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";

import { AuthProvider } from "./hooks/useAuth";
import RootRoutes from "routes";
import RootLayout from "RootLayout";
import { Provider } from "react-redux";
import { store } from "store";
import { useEffect } from "react";
import { initialisePusher } from "hooks/usePusher";
import mixpanel from "mixpanel-browser";
import { extractAndStoreReferralCode } from "utils/common";

function App() {
  useEffect(() => {
    initialisePusher();
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || "");
    
    // Extract and store referral code from URL on app load
    extractAndStoreReferralCode();
  }, []);
  return (
    <div className="App">
      <Provider store={store}>
        <Router>
          <AuthProvider>
            <RootLayout>
              <RootRoutes />
            </RootLayout>
          </AuthProvider>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
